import * as React from "react";
import type { SVGProps } from "react";
const SvgTicketWithStar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.904 6.552a1 1 0 0 0-1.788 0L9.674 9.428l-2.83.476a1 1 0 0 0-.541 1.693l1.866 1.866-.489 3.395a1 1 0 0 0 1.438 1.036l2.892-1.45 2.892 1.45a1 1 0 0 0 1.438-1.036l-.489-3.395 1.866-1.866a1 1 0 0 0-.541-1.693l-2.83-.476zm-1.67 4.226.776-1.547.776 1.547a1 1 0 0 0 .728.538l1.417.239-.848.848a1 1 0 0 0-.283.85l.287 1.995-1.619-.812a1 1 0 0 0-.448-.106H12a1 1 0 0 0-.448.106l-1.62.812.288-1.995a1 1 0 0 0-.283-.85l-.848-.848 1.417-.239a1 1 0 0 0 .728-.538"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 3C1.348 3 0 4.348 0 6v4a1 1 0 0 0 1 1c.548 0 1 .452 1 1s-.452 1-1 1a1 1 0 0 0-1 1v4c0 1.652 1.348 3 3 3h18c1.652 0 3-1.348 3-3v-4a1 1 0 0 0-1-1c-.548 0-1-.452-1-1s.452-1 1-1a1 1 0 0 0 1-1V6c0-1.652-1.348-3-3-3zM2 6c0-.548.452-1 1-1h18c.548 0 1 .452 1 1v3.172A3.01 3.01 0 0 0 20 12c0 1.302.837 2.415 2 2.828V18c0 .548-.452 1-1 1H3c-.548 0-1-.452-1-1v-3.172A3.01 3.01 0 0 0 4 12a3.01 3.01 0 0 0-2-2.828z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTicketWithStar;
